"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[786],{

/***/ 17737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useSearchThrottle; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./common/hooks/useThrottle.ts


function useThrottle(func, delay) {
    var ref = (0,compat_module.useState)(null), timeout = ref[0], saveTimeout = ref[1];
    var throttledFunc = function throttledFunc() {
        //eslint-disable-next-line
        var args = arguments;
        if (timeout) {
            clearTimeout(timeout);
        }
        var newTimeout = setTimeout(function() {
            func.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
            if (newTimeout === timeout) {
                saveTimeout(null);
            }
        }, delay);
        saveTimeout(newTimeout);
    };
    return throttledFunc;
} /* Usage example:
const searchItems =  useThrottle((search:string) => {
  doThing()
}, 100)
*/ 

;// CONCATENATED MODULE: ./common/hooks/useSearchThrottle.ts


function useSearchThrottle(defaultValue, cb) {
    var ref = (0,compat_module.useState)(defaultValue), search = ref[0], setSearch = ref[1];
    var ref1 = (0,compat_module.useState)(search), searchInput = ref1[0], setSearchInput = ref1[1];
    var searchItems = useThrottle(function(search) {
        setSearch(search);
        cb === null || cb === void 0 ? void 0 : cb(search);
    }, 200);
    (0,compat_module.useEffect)(function() {
        searchItems(searchInput);
    //eslint-disable-next-line
    }, [
        searchInput
    ]);
    return {
        search: search,
        searchInput: searchInput,
        setSearchInput: setSearchInput
    };
} /* Usage example:
const searchItems =  useThrottle((search:string) => {
  doThing()
}, 100)
*/ 


/***/ }),

/***/ 45648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ useCreateAssignAllCompanyGroupsMutation; },
/* harmony export */   "Vh": function() { return /* binding */ useCreateAssignCompanyGroupsMutation; }
/* harmony export */ });
/* unused harmony exports assignCompanyGroupService, createAssignCompanyGroups, createAssignAllCompanyGroups */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10092);
/* harmony import */ var common_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24125);
/* harmony import */ var _useSubscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28486);
/* harmony import */ var common_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71185);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10271);








var assignCompanyGroupService = common_service__WEBPACK_IMPORTED_MODULE_0__/* .service.enhanceEndpoints */ .Xn.enhanceEndpoints({
    addTagTypes: [
        "AssignCompanyGroup"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            createAssignAllCompanyGroups: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "AssignCompanyGroup"
                    }
                ],
                query: function(_param) {
                    var from = _param.from, to = _param.to, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
                        "from",
                        "to"
                    ]);
                    return {
                        body: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest),
                        method: "PUT",
                        url: "partners/groups/".concat(from, "/companies/move/").concat(to)
                    };
                },
                transformResponse: function(res) {
                    (0,common_store__WEBPACK_IMPORTED_MODULE_2__/* .getStore */ .b)().dispatch(_useSubscription__WEBPACK_IMPORTED_MODULE_1__/* .subscriptionService.util.invalidateTags */ .AB.util.invalidateTags([
                        "Subscription"
                    ]));
                    return res;
                }
            }),
            createAssignCompanyGroups: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "AssignCompanyGroup"
                    }
                ],
                queryFn: function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(query, _1, _2, baseQuery) {
                        var companies, toRemove, ref, data, error;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    companies = (0,lodash__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(query.subscriptions, function(v) {
                                        return v.company_id;
                                    }).filter(function(v) {
                                        var ref, ref1;
                                        return ((ref = v.groups) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.group_id) !== query.to;
                                    });
                                    toRemove = companies.filter(function(v) {
                                        var ref, ref1;
                                        return !!((ref = v.groups) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.group_id);
                                    });
                                    //Remove any existing company groups
                                    return [
                                        4,
                                        Promise.all(toRemove.map(function(v) {
                                            var ref;
                                            return (ref = v.groups) === null || ref === void 0 ? void 0 : ref.map(function(group) {
                                                return baseQuery({
                                                    body: {},
                                                    method: "DELETE",
                                                    url: "partners/groups/".concat(group.group_id, "/companies/").concat(group.id)
                                                });
                                            });
                                        }))
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        4,
                                        baseQuery({
                                            body: {
                                                company_ids: companies.map(function(v) {
                                                    return v.company_id;
                                                })
                                            },
                                            method: "POST",
                                            url: "partners/groups/".concat(query.to, "/companies")
                                        })
                                    ];
                                case 2:
                                    ref = _state.sent(), data = ref.data, error = ref.error;
                                    (0,common_store__WEBPACK_IMPORTED_MODULE_2__/* .getStore */ .b)().dispatch(_useSubscription__WEBPACK_IMPORTED_MODULE_1__/* .subscriptionService.util.invalidateTags */ .AB.util.invalidateTags([
                                        "Subscription"
                                    ]));
                                    return [
                                        2,
                                        {
                                            data: data,
                                            error: error
                                        }
                                    ];
                            }
                        });
                    });
                    return function(query, _1, _2, baseQuery) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })
        };
    }
});
function createAssignCompanyGroups(store, data, options) {
    return _createAssignCompanyGroups.apply(this, arguments);
}
function _createAssignCompanyGroups() {
    _createAssignCompanyGroups = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(assignCompanyGroupService.endpoints.createAssignCompanyGroups.initiate(data, options))
            ];
        });
    });
    return _createAssignCompanyGroups.apply(this, arguments);
}
function createAssignAllCompanyGroups(store, data, options) {
    return _createAssignAllCompanyGroups.apply(this, arguments);
}
function _createAssignAllCompanyGroups() {
    _createAssignAllCompanyGroups = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(assignCompanyGroupService.endpoints.createAssignAllCompanyGroups.initiate(data, options))
            ];
        });
    });
    return _createAssignAllCompanyGroups.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useCreateAssignAllCompanyGroupsMutation = assignCompanyGroupService /* Usage examples:
const { data, isLoading } = useGetAssignCompanyGroupsQuery({ id: 2 }, {}) //get hook
const [createAssignCompanyGroups, { isLoading, data, isSuccess }] = useCreateAssignCompanyGroupsMutation() //create hook
assignCompanyGroupService.endpoints.getAssignCompanyGroups.select({id: 2})(store.getState()) //access data from any function
*/ .useCreateAssignAllCompanyGroupsMutation, useCreateAssignCompanyGroupsMutation = assignCompanyGroupService.useCreateAssignCompanyGroupsMutation;


/***/ }),

/***/ 71808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ money; }
/* harmony export */ });
/* harmony import */ var common_project__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36877);

function money(value) {
    if (value) {
        return value === null || value === void 0 ? void 0 : value.toLocaleString(common_project__WEBPACK_IMPORTED_MODULE_0__/* .Project.locale */ .I.locale, {
            currency: common_project__WEBPACK_IMPORTED_MODULE_0__/* .Project.currency */ .I.currency,
            style: "currency"
        });
    }
    return 0..toLocaleString(common_project__WEBPACK_IMPORTED_MODULE_0__/* .Project.locale */ .I.locale, {
        currency: common_project__WEBPACK_IMPORTED_MODULE_0__/* .Project.currency */ .I.currency,
        style: "currency"
    });
}


/***/ }),

/***/ 22414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   "rx": function() { return /* binding */ trackCancelSubscription; }
/* harmony export */ });
/* unused harmony export getEventData */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var data_relay__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47277);
/* harmony import */ var data_relay__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(data_relay__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var common_project__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36877);




function getEventData(sub, user) {
    var plan = user === null || user === void 0 ? void 0 : user.products.find(function(p) {
        return "".concat(p.id) === "".concat(sub.plan_id);
    });
    var eventData = {
        event: "Sale",
        propertyString1: "INVOICE",
        propertyString2: (plan === null || plan === void 0 ? void 0 : plan.billing_period) === 2 ? "year" : "month",
        propertyString3: "".concat(user.tenant_id),
        sku: plan === null || plan === void 0 ? void 0 : plan.name,
        source: user.partner_name,
        total: !!plan && ((plan === null || plan === void 0 ? void 0 : plan.billing_period) === 2 ? parseInt(plan.cost / 12 * 100) : parseInt(plan.cost * 100))
    };
    return eventData;
}
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(data, user) {
    try {
        if (!common_project__WEBPACK_IMPORTED_MODULE_1__/* .Project.dataRelay */ .I.dataRelay) return;
        var eventData = getEventData(data, user);
        data_relay__WEBPACK_IMPORTED_MODULE_0___default().sendEvent(eventData, {
            apiKey: common_project__WEBPACK_IMPORTED_MODULE_1__/* .Project.dataRelay */ .I.dataRelay
        });
    } catch (e) {}
}
function trackCancelSubscription(data, user) {
    try {
        if (!common_project__WEBPACK_IMPORTED_MODULE_1__/* .Project.dataRelay */ .I.dataRelay) return;
        var eventData = getEventData(data, user);
        data_relay__WEBPACK_IMPORTED_MODULE_0___default().sendEvent((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, eventData), {
            event: "Cancel",
            total: -(eventData.total || 0)
        }), {
            apiKey: common_project__WEBPACK_IMPORTED_MODULE_1__/* .Project.dataRelay */ .I.dataRelay
        });
    } catch (e) {}
}


/***/ }),

/***/ 78111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CancelSubscription; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./components/base/forms/InputGroup.tsx
var InputGroup = __webpack_require__(91263);
// EXTERNAL MODULE: ./components/base/forms/Select.tsx
var Select = __webpack_require__(68046);
// EXTERNAL MODULE: ./components/base/Messages.tsx + 1 modules
var Messages = __webpack_require__(56884);
// EXTERNAL MODULE: ./components/base/forms/Button.tsx
var Button = __webpack_require__(41280);
// EXTERNAL MODULE: ./components/base/ModalDefault.tsx
var ModalDefault = __webpack_require__(17977);
// EXTERNAL MODULE: ./components/base/Toast.tsx
var Toast = __webpack_require__(12198);
// EXTERNAL MODULE: ./common/service.ts + 7 modules
var service = __webpack_require__(24125);
// EXTERNAL MODULE: ./common/store.ts + 3 modules
var store = __webpack_require__(71185);
// EXTERNAL MODULE: ./common/services/useSubscription.ts + 1 modules
var useSubscription = __webpack_require__(28486);
;// CONCATENATED MODULE: ./common/services/useCancelSubscription.ts





var cancelSubscriptionService = service/* service.enhanceEndpoints */.Xn.enhanceEndpoints({
    addTagTypes: [
        "CancelSubscription"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            createCancelSubscription: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "CancelSubscription"
                    }
                ],
                query: function(query) {
                    return {
                        body: query,
                        method: "POST",
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.id, "/cancel")
                    };
                },
                transformResponse: function(res) {
                    (0,store/* getStore */.b)().dispatch(useSubscription/* subscriptionService.util.invalidateTags */.AB.util.invalidateTags([
                        "Subscription"
                    ]));
                    return res;
                }
            })
        };
    }
});
function createCancelSubscription(store, data, options) {
    return _createCancelSubscription.apply(this, arguments);
}
function _createCancelSubscription() {
    _createCancelSubscription = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(cancelSubscriptionService.endpoints.createCancelSubscription.initiate(data, options))
            ];
        });
    });
    return _createCancelSubscription.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useCreateCancelSubscriptionMutation = cancelSubscriptionService /* Usage examples:
const { data, isLoading } = useGetCancelSubscriptionQuery({ id: 2 }, {}) //get hook
const [createCancelSubscription, { isLoading, data, isSuccess }] = useCreateCancelSubscriptionMutation() //create hook
cancelSubscriptionService.endpoints.getCancelSubscription.select({id: 2})(store.getState()) //access data from any function
*/ .useCreateCancelSubscriptionMutation;

;// CONCATENATED MODULE: ./components/CancelSubscription.tsx










var CancelSubscription = function(param) {
    var customerId = param.customerId, id = param.id, isOpen = param.isOpen, onCancel = param.onCancel, setIsOpen = param.setIsOpen;
    var ref = (0,compat_module.useState)(true), immediateCancel = ref[0], setImmediateCancel = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(useCreateCancelSubscriptionMutation({}), 2), cancelSubscription = ref1[0], ref2 = ref1[1], cancelError = ref2.error, cancelLoading = ref2.isLoading;
    var doCancel = function() {
        cancelSubscription({
            company_id: customerId,
            id: id,
            reason: "Requested",
            termination_type: immediateCancel ? "IMMEDIATE" : "END_OF_TERM"
        }).then(function(res) {
            //@ts-ignore
            if (!res.error) {
                setIsOpen(false);
                (0,Toast/* toast */.Am)("Success", "Cancelled Customer Subscription");
                onCancel === null || onCancel === void 0 ? void 0 : onCancel();
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ModalDefault/* default */.Z, {
        title: "Cancel Subscription",
        isOpen: isOpen,
        onDismiss: function() {
            return setIsOpen(false);
        },
        toggle: function() {
            return setIsOpen(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InputGroup/* default */.Z, {
                title: "When do you want to cancel the subscription?",
                component: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Select/* default */.Z, {
                    onChange: function(v) {
                        return setImmediateCancel(v.value);
                    },
                    value: immediateCancel ? {
                        label: "Immediately",
                        value: true
                    } : {
                        label: "End of Term",
                        value: false
                    },
                    options: [
                        {
                            label: "End of Term",
                            value: false
                        },
                        {
                            label: "Immediately",
                            value: true
                        }, 
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Messages/* ErrorMessage */.Bc, {
                className: "mt-2",
                children: cancelError
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "text-end mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                        onClick: function() {
                            setIsOpen(false);
                        },
                        className: "me-2",
                        theme: "secondary",
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                        onClick: doCancel,
                        disabled: cancelLoading,
                        className: "me-2",
                        theme: "danger",
                        children: "Confirm Cancellation"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CancelSubscription = (CancelSubscription);


/***/ }),

/***/ 2042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react_calendar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16191);



var DatePicker = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_calendar__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            formatShortWeekday: function(_, d) {
                return d.toLocaleString("en", {
                    weekday: "short"
                }).slice(0, 2);
            },
            showNeighboringMonth: true
        }, props))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DatePicker);


/***/ }),

/***/ 50152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var components_base_forms_Select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68046);
/* harmony import */ var common_services_useGroup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64344);




var GroupSelect = function(param) {
    var className = param.className, defaultValue = param.defaultValue, disabled = param.disabled, excludeGroups = param.excludeGroups, isMulti = param.isMulti, label = param.label, onChange = param.onChange, showID = param.showID, value = param.value;
    var ref;
    var data = (0,common_services_useGroup__WEBPACK_IMPORTED_MODULE_3__/* .useGetGroupsQuery */ .Ky)({}).data;
    var options = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return ((data === null || data === void 0 ? void 0 : data.results) || []).map(function(v) {
            return {
                label: "".concat(v.name),
                value: v.id
            };
        });
    }, [
        data
    ]);
    var values = options === null || options === void 0 ? void 0 : options.filter(function(b) {
        return typeof value !== "number" ? value === null || value === void 0 ? void 0 : value.includes(b.value) : value === b.value;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("label", {
                className: "fw-semibold fs-lg mb-2",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: "d-flex gap-4",
                children: (data === null || data === void 0 ? void 0 : (ref = data.results) === null || ref === void 0 ? void 0 : ref.length) === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                    className: "text-center",
                    children: "You have no groups, you can set these up within Team settings."
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_base_forms_Select__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    isDisabled: disabled,
                    className: "w-100",
                    isMulti: isMulti,
                    value: values,
                    onChange: function(v) {
                        onChange(v);
                    },
                    options: (defaultValue ? options.filter(function(b) {
                        return b.value !== defaultValue;
                    }) : options).filter(function(v) {
                        if (excludeGroups) {
                            return !excludeGroups.includes(v.value);
                        }
                        return true;
                    }),
                    getOptionLabel: showID ? function(option) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: "d-flex gap-1 align-items-center",
                                children: option.label
                            })
                        });
                    } : undefined
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GroupSelect);


/***/ }),

/***/ 5109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var components_base_Badge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84376);
/* harmony import */ var common_utils_string_enumeration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70752);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);




var KYCStatus = function(param) {
    var className = param.className, subscription = param.subscription;
    if (!subscription) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("d-flex align-items-center", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_base_Badge__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            className: className,
            theme: subscription.status === "ACTIVE" ? "success" : subscription.status === "NO_ID" ? "warning" : "danger",
            children: common_utils_string_enumeration__WEBPACK_IMPORTED_MODULE_2__/* .enumeration.get */ .J.get(subscription.status)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (KYCStatus);


/***/ }),

/***/ 7977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ project_PlanName; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./common/types/responses.ts
var responses = __webpack_require__(7061);
// EXTERNAL MODULE: ./common/utils/number/money.ts
var money = __webpack_require__(71808);
;// CONCATENATED MODULE: ./common/utils/project/planCost.ts


/* harmony default export */ function planCost(product) {
    if (!product) {
        return null;
    }
    return "".concat((0,money/* default */.Z)(product.cost), " per ").concat(product.billing_period === responses/* BillingPeriod.MONTHLY */.tv.MONTHLY ? "month" : "year");
}

// EXTERNAL MODULE: ./common/services/useUser.ts
var useUser = __webpack_require__(99195);
;// CONCATENATED MODULE: ./components/project/PlanName.tsx



 // we need this to make JSX compile
var PlanName = function(param) {
    var id = param.id, short = param.short;
    var ref;
    var data = (0,useUser/* useUser */.aF)({}).data;
    var matchingItem = data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.find(function(v) {
        return "".concat(v.id) === "".concat(id);
    });
    if (short && matchingItem) {
        return matchingItem.name;
    }
    return matchingItem ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: "d-flex flex-column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "fw-bold",
                children: matchingItem.name
            }),
            planCost(matchingItem)
        ]
    }) : null;
};
/* harmony default export */ var project_PlanName = (PlanName);


/***/ })

}]);